// extracted by mini-css-extract-plugin
export default {"SidebarSection":"SidebarSection_SidebarSection__s1E0X","SidebarSection__heading":"SidebarSection_SidebarSection__heading__nRZMC"};